import { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

interface MenuItem {
  label: string;
  path: string;
  icon: string;
}

const menuItems: MenuItem[] = [
  { label: 'Dashboard', path: '/', icon: 'ri-dashboard-line' },
  { label: 'Siparişler', path: '/orders', icon: 'ri-shopping-bag-line' },
  { label: 'Üretim Takibi', path: '/production', icon: 'ri-tools-line' },
  { label: 'Kargo Takibi', path: '/cargo', icon: 'ri-truck-line' },
  { label: 'Müşteri Mesajları', path: '/messages', icon: 'ri-chat-3-line' },
  { label: 'Cari Takip', path: '/finance', icon: 'ri-money-dollar-circle-line' },
  { label: 'Ürünler', path: '/products', icon: 'ri-stack-line' },
  { label: 'Raporlar', path: '/reports', icon: 'ri-bar-chart-line' },
  { label: 'Ayarlar', path: '/settings', icon: 'ri-settings-3-line' },
];

export default function Sidebar() {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  return (
    <>
      {/* Mobile overlay */}
      {mobileOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 md:hidden"
          onClick={() => setMobileOpen(false)}
        />
      )}

      {/* Mobile toggle button */}
      <button
        className="fixed top-3 left-3 z-50 w-10 h-10 flex items-center justify-center bg-panel-dark text-white rounded-lg md:hidden"
        onClick={() => setMobileOpen(!mobileOpen)}
      >
        <i className={`${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-lg`} />
      </button>

      {/* Sidebar */}
      <aside
        className={`fixed top-0 left-0 h-screen bg-panel-darker z-50 transition-all duration-300 flex flex-col
          ${mobileOpen ? 'translate-x-0' : '-translate-x-full'} 
          md:translate-x-0 md:static
          ${collapsed ? 'w-20' : 'w-64'}`}
      >
        {/* Logo */}
        <div className={`flex items-center h-16 px-5 border-b border-panel-border flex-shrink-0 ${collapsed ? 'justify-center' : ''}`}>
          {collapsed ? (
            <span className="font-heading text-gold-500 text-xl font-bold">T</span>
          ) : (
            <div className="flex items-center gap-2.5">
              <span className="font-heading text-gold-500 text-2xl font-bold tracking-tight">Tablocum</span>
              <span className="text-white/60 text-xs font-medium bg-white/10 px-1.5 py-0.5 rounded">.11</span>
            </div>
          )}
        </div>

        {/* Navigation */}
        <nav className="flex-1 overflow-y-auto sidebar-scroll py-3 px-3">
          {menuItems.map((item) => {
            const isActive = item.path === '/' 
              ? location.pathname === '/' 
              : location.pathname.startsWith(item.path);
            return (
              <NavLink
                key={item.path}
                to={item.path}
                onClick={() => setMobileOpen(false)}
                className={`flex items-center gap-3 px-3 py-2.5 rounded-lg mb-1 transition-all duration-200 group whitespace-nowrap
                  ${isActive 
                    ? 'bg-gold-500/15 text-gold-400' 
                    : 'text-white/60 hover:text-white hover:bg-white/5'
                  }`}
              >
                <i className={`${item.icon} text-lg w-5 h-5 flex items-center justify-center flex-shrink-0`} />
                {!collapsed && (
                  <span className="text-sm font-medium">{item.label}</span>
                )}
                {isActive && !collapsed && (
                  <span className="ml-auto w-1.5 h-1.5 rounded-full bg-gold-500 flex-shrink-0" />
                )}
              </NavLink>
            );
          })}
        </nav>

        {/* Collapse toggle - desktop only */}
        <button
          className="hidden md:flex items-center justify-center h-10 border-t border-panel-border text-white/40 hover:text-white/70 transition-colors flex-shrink-0"
          onClick={() => setCollapsed(!collapsed)}
        >
          <i className={`${collapsed ? 'ri-arrow-right-s-line' : 'ri-arrow-left-s-line'} text-lg`} />
        </button>

        {/* User info */}
        <div className={`border-t border-panel-border p-4 flex-shrink-0 ${collapsed ? 'items-center justify-center' : ''}`}>
          {collapsed ? (
            <div className="w-8 h-8 rounded-full bg-gold-500/20 flex items-center justify-center text-gold-400 text-xs font-bold">
              AU
            </div>
          ) : (
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 rounded-full bg-gold-500/20 flex items-center justify-center text-gold-400 text-xs font-bold flex-shrink-0">
                AU
              </div>
              <div className="min-w-0">
                <p className="text-white text-sm font-medium truncate">Ali Usta</p>
                <p className="text-gold-500/70 text-xs truncate">Yönetici</p>
              </div>
            </div>
          )}
        </div>
      </aside>
    </>
  );
}